import { initializeApp } from "firebase/app";
import {
  getAuth,
  Auth,
  setPersistence,
  browserSessionPersistence,
  connectAuthEmulator
} from "firebase/auth";

/**
 * Firebase Configuration for Cubemate
 * Replace the config below with your Firebase project config from Firebase Console
 *
 * To get this config:
 * 1. Go to Firebase Console → Project Settings
 * 2. Copy the web app config
 */

// TODO: Replace with your Firebase config from Firebase Console
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyExample",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "cubemate-xxxxx.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "cubemate-xxxxx",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "cubemate-xxxxx.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:123456789:web:abcdef",
};

console.log("[Firebase] Initializing with project:", firebaseConfig.projectId);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth: Auth = getAuth(app);

// Set auth persistence to session (tokens cleared on browser close)
setPersistence(auth, browserSessionPersistence).catch((error: any) => {
  console.error("[Firebase] Error setting persistence:", error);
});

// Enable auth emulator for development (optional)
// v3.19.7.2: hostname check now covers BOTH prod domains (cubemate.ai canonical + cubemate.app legacy).
// Emulator should only fire on local dev / non-prod hosts.
const isProdHost = window.location.hostname.includes("cubemate.ai") || window.location.hostname.includes("cubemate.app");
if (process.env.REACT_APP_FIREBASE_EMULATOR === "true" && !isProdHost) {
  console.log("[Firebase] Using Auth Emulator on localhost:9099");
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
}

console.log("[Firebase] ✅ Firebase Auth initialized");

export default app;
